class StarProductRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-star-product-track]');
    this.previousButton = this.querySelector('[data-star-product-previous]');
    this.nextButton = this.querySelector('[data-star-product-next]');

    if (!(this.track instanceof HTMLElement)) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.previousButton?.addEventListener('click', () => this.scroll(-1), { signal });
    this.nextButton?.addEventListener('click', () => this.scroll(1), { signal });
    this.track.addEventListener('scroll', this.queueStateUpdate, { passive: true, signal });

    this.resizeObserver = new ResizeObserver(this.queueStateUpdate);
    this.resizeObserver.observe(this.track);
    this.queueStateUpdate();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.stateFrame);
  }

  queueStateUpdate = () => {
    cancelAnimationFrame(this.stateFrame);
    this.stateFrame = requestAnimationFrame(() => this.updateButtonState());
  };

  scroll(direction) {
    if (!(this.track instanceof HTMLElement)) return;

    const firstCard = this.track.querySelector('.star-featured-catalogue__product-card');
    if (!(firstCard instanceof HTMLElement)) return;

    const trackStyle = getComputedStyle(this.track);
    const gap = Number.parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
    const step = firstCard.getBoundingClientRect().width + gap;
    const cardsPerView = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.track.scrollBy({
      left: direction * step * cardsPerView,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  }

  updateButtonState() {
    if (!(this.track instanceof HTMLElement)) return;

    const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const currentScroll = Math.abs(this.track.scrollLeft);
    const hasOverflow = maxScroll > 2;

    if (this.previousButton instanceof HTMLButtonElement) {
      this.previousButton.hidden = !hasOverflow;
      this.previousButton.disabled = currentScroll <= 2;
    }

    if (this.nextButton instanceof HTMLButtonElement) {
      this.nextButton.hidden = !hasOverflow;
      this.nextButton.disabled = currentScroll >= maxScroll - 2;
    }
  }
}

if (!customElements.get('star-product-rail')) {
  customElements.define('star-product-rail', StarProductRail);
}
